













































import Vue, { PropType } from 'vue';

import * as InputValidation from '@/mixins/inputValidation';

import { Objective } from '@/models/packet';

export default Vue.extend({
  props: {
    objective: {
      type: Object as PropType<Objective>,
      required: true
    },
    showHints: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isEditing: false,
      nameInput: this.objective.name,
      descriptionInput: this.objective.description
    };
  },

  computed: {
    saveDisabled(): boolean {
      return (
        (this.nameInput === this.objective.name &&
          this.descriptionInput === this.objective.description) ||
        !this.nameValidation.valid ||
        !this.descriptionValidation.valid
      );
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 1250);
    }
  },

  methods: {
    save() {
      this.$emit('update', {
        ...this.objective,
        name: this.nameInput,
        description: this.descriptionInput
      });

      this.close();
    },

    close() {
      this.isEditing = false;
    }
  }
});
